import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { backendUrl } from 'src/environments/environment';
import { Location } from './authentication.store';
import { Product, ProductsResponse } from './product.store';
import { toPromise } from './toPromise';

export interface Item {
  product_id: number;
  product_name: string;
  images: Array<images>;
  qty: number;
  price: number;
  actual_price: number;
  saving: number;
  total: number;
  option_data: string;
  options: Array<Option>;
  selected: boolean;
}

export interface images {
  id: number;
  product_id: number;
  thumbnail: string;
  full: string;
  created_at: string;
  updated_at: string;
  deleted_at: Date;
}

export interface Option {
  id: number;
  product_id: number;
  img: string;
  variation_name: string;
  variation_price: number;
  variation_type: number;
  inventory: number;
  sku: string;
  created_at: string;
  updated_at: string;
  deleted_at: Date;
  variation_types: VariationType;
}

export interface VariationType {
  id: number;
  variation_name: string;
  seller_id: number;
}

export interface CartUpdate {
  cart_id: number;
  product_id: number;
  qty: number;
  product_variation: Array<productVariation>;
  is_rentable?: number;
}

export interface productVariation {
  id: number;
  variation_fields?: Array<{
    id: number;
  }>;
}

export interface CartItem {
  seller_id: number;
  delivery_charges: number;
  seller_name: String;
  items: Array<Product>;
  item_total: number;
  total_saving: number;
  selectAll?: boolean;
  shippingMethod?: number;
  seller_pickup_locations: Location;
}

export interface CartDetail {
  cart: Array<CartItem>;
  cart_id: number;
  total_saving: number;
  discount: number;
  total: number;
  grand_total: number;
  total_items: number;
  message: string;
  selectAll?: boolean;
}

export interface Cart {
  status: Boolean;
  data: CartDetail;
}

export interface OrderPayload {
  cart_id: number;
  coupon_code: string;
  payment_method: string;
  billing_locations: number;
  delivery_locations: number;
  shipping_method: Array<ShippingMethods>;
  items: Array<number>;
}

export interface ShippingMethods {
  type: number;
  seller_id: number;
}

export interface CartRemove {
  product_id?: number;
  seller_id?: number;
  options: number;
}

export interface getFare {
  seller_id: number;
  delivery_locations: number;
}

@Injectable({
  providedIn: 'root',
})
export class CheckoutStore {
  cartData: CartDetail;
  checkoutData: Array<CartItem>;
  constructor(private httpClient: HttpClient) {}

  async getCheckout(params = null): Promise<Cart> {
    const url = `${backendUrl}cart`;
    const token = localStorage.getItem('authToken');
    var headers;
    if (token) {
      headers = new HttpHeaders({
        Authorization: `Bearer ${token}`,
      });
    }
    return toPromise(
      this.httpClient.get<Cart>(url, {
        params: params,
        headers: headers,
      })
    );
  }

  async postCartAddUpdate(params: CartUpdate = null): Promise<Cart> {
    const url = `${backendUrl}cart`;
    const token = localStorage.getItem('authToken');
    var headers;
    if (token) {
      headers = new HttpHeaders({
        Authorization: `Bearer ${token}`,
      });
    }
    var cartResponse = toPromise(
      this.httpClient.post<Cart>(url, params, {
        headers: headers,
      })
    );

    this.cartData = (await cartResponse).data;

    return cartResponse;
  }

  async getCartItems(params = null): Promise<Cart> {
    const url = `${backendUrl}cart`;
    const token = localStorage.getItem('authToken');
    var headers;
    if (token) {
      headers = new HttpHeaders({
        Authorization: `Bearer ${token}`,
      });
    }
    var cartResponse = toPromise(
      this.httpClient.post<Cart>(
        url,
        {},
        {
          params: params,
          headers: headers,
        }
      )
    );

    this.cartData = (await cartResponse).data;
    return cartResponse;
  }

  async addOrder(params = null): Promise<OrderPayload> {
    const url = `${backendUrl}order`;
    const token = localStorage.getItem('authToken');
    var headers;
    if (token) {
      headers = new HttpHeaders({
        Authorization: `Bearer ${token}`,
      });
    }
    var resp = toPromise(
      this.httpClient.post<OrderPayload>(url, params, {
        headers: headers,
      })
    );
    return resp;
  }

  async removeCartItem(params: CartRemove = null): Promise<Cart> {
    const url = `${backendUrl}empty-cart`;
    const token = localStorage.getItem('authToken');
    var headers;
    if (token) {
      headers = new HttpHeaders({
        Authorization: `Bearer ${token}`,
      });
    }
    var cartResponse = toPromise(
      this.httpClient.post<Cart>(url, params, {
        headers: headers,
      })
    );

    this.cartData = (await cartResponse).data;

    return cartResponse;
  }

  async getDeliveryFare(payload: getFare = null): Promise<void> {
    const url = `${backendUrl}get-fare`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.post<void>(url, payload, {
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }
  async getSimiliarProd(): Promise<ProductsResponse> {
    const url = `${backendUrl}cart-similiar-items`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.get<ProductsResponse>(url, {
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }

  s;
  updateTotals() {
    this.cartData.total = 0;
    this.cartData.total_saving = 0;
    this.cartData.cart.forEach((cart, i) => {
      var itemTotal = 0;
      var itemSaving = 0;
      var items = cart.items.filter((item) => item.selected);
      if (items.length > 0) {
        items.forEach((item) => {
          itemTotal = itemTotal + item.price * item.qty;
          itemSaving = itemSaving + item.actual_price * item.qty;
        });
        this.cartData.cart[i].item_total = itemTotal;
        this.cartData.cart[i].total_saving = itemSaving;
        this.cartData.total = this.cartData.total + itemTotal;
        this.cartData.total_saving = this.cartData.total_saving + itemSaving;
      }
    });
  }
}
